import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import AddItemGroupForm from "./AddItemGroupForm";
import NewItemGroupInfoPage from "../NewItemGroupInfoPage";
import ItemGroupImageUpload from "./ItemGroupImageUpload";

import { itemsGroupService } from "../../services/itemGroup.service";
import { GetGroupEdit, GetGroupImageEdit, SetGroupEdit } from "../../store/itemGroupAtom";
import LogicContext from "../../Context/LogicContext";

const TAB = {
  GROUP_INFORMATION: "GROUP_INFORMATION",
  ITEM_INFORMATION: "ITEM_INFORMATION",
  GROUP_IMAGE: "GROUP_IMAGE",
};

const TABS = [
  { key: TAB.GROUP_INFORMATION, label: "Group Information" },
  { key: TAB.ITEM_INFORMATION, label: "Item Information" },
  { key: TAB.GROUP_IMAGE, label: "Pictures" },
];

function AddItemGroup() {
  const navigate = useNavigate();
  const groupToEdit = GetGroupEdit();
  const setGroupEdit = SetGroupEdit();
  const getGroupImageEdit = GetGroupImageEdit();
  const logicContext = useContext(LogicContext);

  const [currentTab, setCurrentTab] = useState(TAB.GROUP_INFORMATION);
  const [newItemId, setNewItemId] = useState(undefined);




  useEffect(()=> {

    return ()=> {
      setGroupEdit({})
    }

  },[]);

  useEffect(() => {
    setNewItemId(groupToEdit?.Item_Group_Id);
  }, [groupToEdit?.Item_Group_Id]);

  const handleTabChange = (tabKey) => {
    setCurrentTab(tabKey);
  };

  const submitGroupInformation = (data) => {
    const action = newItemId
      ? itemsGroupService.updateItemGroup
      : itemsGroupService.submitItemGroup;

    action(data)
      .then((res) => {
        const { message_id, message_text, message_ref_no } = res.data[0];
        if (message_id === 5 || message_id === 6) {
          logicContext.showToast(message_text, "error");
        } else {
          logicContext.showToast(message_text, "success");
          setNewItemId(message_ref_no);
          setCurrentTab(TAB.GROUP_INFORMATION);
        }
      })
      .catch(() => {});
  };

  const submitGroupInfo = (data) => {
    itemsGroupService
      .saveGroupItems(data)
      .then((res) => {
        logicContext.showToast(res?.data[0]["message_text"], "success");
        setCurrentTab(TAB.GROUP_IMAGE);
      })
      .catch(() => {});
  };

  return (
    <section className="bg-white max-w-6xl mx-auto p-4">
      {/* Tabs */}
      <div className="flex flex-wrap gap-2 mb-6">
        {TABS.map((tab) => {
          const isActive = currentTab === tab.key;
          const isDisabled = tab.key !== TAB.GROUP_INFORMATION && !newItemId;

          return (
            <button
              key={tab.key}
              disabled={isDisabled}
              onClick={() => handleTabChange(tab.key)}
              className={`px-3 py-2.5 rounded text-sm font-medium transition-colors duration-150 ${
                isDisabled
                  ? "bg-gray-200 text-gray-500 cursor-not-allowed"
                  : isActive
                  ? "bg-primary text-white"
                  : "bg-gray-100 hover:bg-gray-200"
              }`}
            >
              {tab.label}
            </button>
          );
        })}
      </div>

      {/* Tab Content */}
      <div className="">
        {currentTab === TAB.GROUP_INFORMATION && (
          <AddItemGroupForm submitForm={submitGroupInformation} />
        )}
        {currentTab === TAB.ITEM_INFORMATION && newItemId && (
          <NewItemGroupInfoPage
            submitGroupInfo={submitGroupInfo}
            item_group_id={newItemId}
          />
        )}
        {currentTab === TAB.GROUP_IMAGE && newItemId && (
          <ItemGroupImageUpload
            Item_Id={newItemId}
            getListToEdit={getGroupImageEdit}
          />
        )}
      </div>
    </section>
  );
}

export default AddItemGroup;
